import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tutorial-start" }
const _hoisted_2 = { class: "tutorial-start__item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "tutorial-start__title" }, "Welcome!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "tutorial-start__text" }, " Let’s go on a quick tour of a Shortform book guide. ", -1)
const _hoisted_5 = { class: "tutorial-start__btn-box" }
const _hoisted_6 = { class: "tutorial-start__item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "tutorial-start__title" }, "1-Page Summary", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "tutorial-start__text" }, " Every guide starts with a 1-Page Summary. This is a 5-10 minute overview of the book’s key points. ", -1)
const _hoisted_9 = { class: "tutorial-start__btn-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "tutorial-start__btn-arr iconfont inext" }, null, -1)
const _hoisted_11 = { class: "tutorial-question" }
const _hoisted_12 = { class: "tutorial-start__item tutorial-start__question" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "tutorial-start__title" }, "Finished!", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "tutorial-start__text" }, " If you ever need to see this tour again, click here. ", -1)
const _hoisted_15 = { class: "tutorial-start__btn-box" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tutorial-question__icon iconfont iquestion" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "tutorial-question__tips" }, "Guided Tour", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

import { BookTutorial } from '@/models/doc.tutorial'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tutorial',
  props: {
    bookTutorial: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            class: "tutorial-start__btn tutorial-start__btn--no-arr tutorial-next btns",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.bookTutorial.incrementStep()))
          }, "Start")
        ])
      ], 512), [
        [_vShow, __props.bookTutorial.step === 1]
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                class: "tutorial-start__btn tutorial-next btns",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.bookTutorial.incrementStep()))
              }, [
                _createTextVNode("Next"),
                _hoisted_10
              ])
            ])
          ], 512), [
            [_vShow, __props.bookTutorial.step === 2]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                class: "tutorial-start__btn tutorial-start__btn--no-arr tutorial-close btns",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.bookTutorial.resetStep()))
              }, "Close")
            ])
          ], 512), [
            [_vShow, __props.bookTutorial.step === 8]
          ]),
          _withDirectives(_createElementVNode("a", {
            class: "tutorial-question__btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.bookTutorial.start()))
          }, _hoisted_18, 512), [
            [_vShow, __props.bookTutorial.isVisible()]
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})